'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PassRecoveryStepThreeView: {
        displayName: 'PassRecoveryStepThreeView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/PassRecovery/PassRecoveryStepThree/default/PassRecoveryStepThreeView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var PassRecoveryStepThreeView = _wrapComponent('PassRecoveryStepThreeView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(PassRecoveryStepThreeView, _Component);

    function PassRecoveryStepThreeView(props) {
        (0, _classCallCheck3.default)(this, PassRecoveryStepThreeView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PassRecoveryStepThreeView.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepThreeView)).call(this, props));

        _this.onShowAuth = function (event) {
            event.preventDefault();
            _this.props.onShowAuth(event);
        };

        return _this;
    }

    (0, _createClass3.default)(PassRecoveryStepThreeView, [{
        key: 'render',
        value: function render() {

            return _react3.default.createElement(
                'div',
                { className: 'text-center' },
                _react3.default.createElement(
                    'p',
                    null,
                    this.props.lang['store.password_recovery.success'],
                    '!'
                ),
                _react3.default.createElement(
                    'a',
                    { href: '#', onClick: this.props.handleClick },
                    '\u0412\u043E\u0439\u0442\u0438'
                )
            );
        }
    }]);
    return PassRecoveryStepThreeView;
}(_react2.Component), _class.propTypes = {
    lang: _react2.PropTypes.object
}, _temp));

exports.default = PassRecoveryStepThreeView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PassRecovery/PassRecoveryStepThree/default/PassRecoveryStepThreeView.jsx
// module id = 1724
// module chunks = 0